// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_status_container__IBUtQ {
  align-items: center;
  display: flex;
  justify-content: center;
}

.styles_aprovado__BkR4j {
  background-color: green;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_analise__b2B59 {
  background-color: orange;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_reprovado__CFE23 {
  background-color: red;
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_revisando__n8Jcp {
  background-color: rgb(255, 102, 0);
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_aguardando__zo8nM {
  background-color: rgb(28, 42, 235);
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}

.styles_aguardandoContrato__H1sEE {
  background-color: rgb(204, 71, 31);
  border-radius: 50%;
  height: 0.7rem;
  margin-right: 0.3rem;
  width: 0.7rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Juridico/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf","sourcesContent":[".status_container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.aprovado {\n  background-color: green;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.analise {\n  background-color: orange;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.reprovado {\n  background-color: red;\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.revisando {\n  background-color: rgb(255, 102, 0);\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.aguardando {\n  background-color: rgb(28, 42, 235);\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n\n.aguardandoContrato {\n  background-color: rgb(204, 71, 31);\n  border-radius: 50%;\n  height: 0.7rem;\n  margin-right: 0.3rem;\n  width: 0.7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status_container": `styles_status_container__IBUtQ`,
	"aprovado": `styles_aprovado__BkR4j`,
	"analise": `styles_analise__b2B59`,
	"reprovado": `styles_reprovado__CFE23`,
	"revisando": `styles_revisando__n8Jcp`,
	"aguardando": `styles_aguardando__zo8nM`,
	"aguardandoContrato": `styles_aguardandoContrato__H1sEE`
};
export default ___CSS_LOADER_EXPORT___;
